<template>
  <div class="mb-10">
    <h1 class="text-secondary text-2xl font-semibold mb-3">
      {{ weekTitle }}
    </h1>
    <div class="pl-10 max-w-full">
      <div id="weeklyMeals" style="width: 1110px; margin: 0 auto;">
        <div v-if="pastMealPlan" class="grid grid-flow-col gap-2.5">
          <MealDay
            v-for="(dailyMeals, index) in meals"
            :key="`week_${week}-${weekDays[index]}`"
            :day="weekDays[index]"
            :past-meal-plan="pastMealPlan"
            :past-meals="dailyMeals"
          />
        </div>
        <div v-else class="grid grid-flow-col gap-2.5">
          <MealDay
            v-for="day in weekDays"
            :key="day"
            :day="day"
            @addNew="addNew"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MealDay from "@/pages/MealPlanner/components/MealDay";
import moment from "moment";

export default {
  name: "MealWeek",
  components: {
    MealDay
  },
  props: {
    pastMealPlan: {
      type: Boolean,
      default: false
    },
    week: {
      type: Number,
      defaul: 0
    },
    start_day: {
      type: Number,
      defaul: 0
    },
    meals: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    weekDays() {
      const firstDay = "Monday";
      const weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ];
      const firstDayIndex = weekDays.indexOf(firstDay);

      return [
        ...weekDays.splice(firstDayIndex, 7),
        ...weekDays.splice(0, firstDayIndex)
      ];
    },
    weekTitle() {
      const format = "D/M";

      if (!this.pastMealPlan) {
        const nextStart = moment()
          .startOf("week")
          .day("Monday")
          .add(7, "d");
        const nextEnd = moment(nextStart).add(6, "d");

        return `Week ${this.week}: ${nextStart.format(
          format
        )} - ${nextEnd.format(format)}`;
      }

      const start = moment.unix(this.start_day).format(format);
      const end = moment
        .unix(this.start_day)
        .add(6, "d")
        .format(format);

      return `Week ${this.week}: ${start} - ${end}`;
    },
    ...mapGetters(["getMyRecipes"])
  },
  data() {
    return {};
  },
  methods: {
    async addNew({ day, recipe }) {
      const meal = {
        [day]: recipe
      };

      this.$store.commit("addMealToDay", meal);
    }
  },
  created() {}
};
</script>

<style></style>
